import React, { useEffect, useState } from "react";
import Loading from "./loading.js";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import "./app.css";
import { secretKey } from "./data";

const MySwal = withReactContent(Swal2);

const QUOTES = [
  {
    text: "Każdy lead to szansa — nie pytanie czy, ale kiedy.",
    author: "Zasada #1",
  },
  {
    text: "Sukces to suma małych wysiłków powtarzanych dzień po dniu.",
    author: "Robert Collier",
  },
  {
    text: "Nie czekaj na idealny moment. Weź ten moment i zrób go idealnym.",
    author: "Zasada sprzedaży",
  },
  {
    text: "Profesjonalizm to robienie tego, co trzeba, nawet gdy nie masz na to ochoty.",
    author: "Zasada #3",
  },
  {
    text: "Twój następny telefon może zmienić czyjeś życie — i Twoje.",
    author: "Motywacja dnia",
  },
  {
    text: "Ludzie nie kupują produktów. Kupują rozwiązania swoich problemów.",
    author: "Zasada sprzedaży",
  },
  {
    text: "Wytrwałość pokonuje talent, gdy talent nie jest wytrwały.",
    author: "Tim Notke",
  },
  {
    text: "Jeden dobry kontakt jest wart więcej niż sto przypadkowych.",
    author: "Zasada #5",
  },
  {
    text: "Słuchaj dwa razy więcej niż mówisz — masz dwoje uszu i jedne usta.",
    author: "Złota reguła",
  },
  {
    text: "Dziś jest dzień, w którym ktoś czeka na Twój telefon.",
    author: "Motywacja dnia",
  },
  {
    text: "Nie sprzedawaj. Pomagaj klientowi kupić.",
    author: "Zasada sprzedaży",
  },
  {
    text: "Energia, którą wnosisz do rozmowy, jest ważniejsza niż skrypt.",
    author: "Zasada #7",
  },
  { text: "Każde 'nie' przybliża Cię do 'tak'.", author: "Prawo liczb" },
  {
    text: "Bądź osobą, której sam chciałbyś zaufać.",
    author: "Zasada zaufania",
  },
  {
    text: "Plan bez działania to marzenie. Działanie bez planu to chaos.",
    author: "Zasada #9",
  },
];

const Login = (props) => {
  const [login, setLogin] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [quoteIdx, setQuoteIdx] = useState(() =>
    Math.floor(Math.random() * QUOTES.length)
  );
  const [quoteFade, setQuoteFade] = useState(true);

  /* ── rotate quotes every 6s ── */
  useEffect(() => {
    const interval = setInterval(() => {
      setQuoteFade(false);
      setTimeout(() => {
        setQuoteIdx((prev) => (prev + 1) % QUOTES.length);
        setQuoteFade(true);
      }, 400);
    }, 6000);
    return () => clearInterval(interval);
  }, []);

  const checkLoginData = async () => {
    if (!login || !password) {
      MySwal.fire({
        icon: "warning",
        title: "Uwaga",
        text: "Wpisz login i hasło",
      });
      return;
    }
    setSubmitting(true);
    try {
      const res = await fetch("https://apiftpsplit.ftpeople.pl/getLoginData", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: secretKey,
        },
        body: JSON.stringify({ login, password }),
      });
      const data = await res.json();
      if (data.length > 0) {
        props.login(data);
      } else {
        await MySwal.fire({
          icon: "error",
          title: "Błąd",
          text: "Nieprawidłowe dane logowania",
        });
        setSubmitting(false);
      }
    } catch {
      setSubmitting(false);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") checkLoginData();
  };

  useEffect(() => {
    setLoading(false);
  }, []);

  if (loading) return <Loading />;

  const quote = QUOTES[quoteIdx];

  return (
    <div className="login-page">
      {/* Left — branding panel */}
      <div className="login-brand">
        <div className="login-brand-content">
          <div className="login-brand-logo">LS</div>
          <h1 className="login-brand-title">Lead Splitter</h1>
          <p className="login-brand-sub">by FTP</p>

          {/* Quote */}
          <div
            className={`login-quote ${quoteFade ? "login-quote--visible" : ""}`}
          >
            <div className="login-quote-mark">"</div>
            <p className="login-quote-text">{quote.text}</p>
            <span className="login-quote-author">— {quote.author}</span>
          </div>

          {/* Dots */}
          <div className="login-quote-dots">
            {QUOTES.map((_, i) => (
              <span
                key={i}
                className={`login-quote-dot ${
                  i === quoteIdx ? "login-quote-dot--active" : ""
                }`}
                onClick={() => {
                  setQuoteFade(false);
                  setTimeout(() => {
                    setQuoteIdx(i);
                    setQuoteFade(true);
                  }, 200);
                }}
              />
            ))}
          </div>
        </div>
        <div className="login-brand-footer">
          <img
            src="https://ftpeople.pl/wp-content/uploads/2024/02/logoftp.png"
            alt="FTP Logo"
            className="login-ftp-logo"
          />
        </div>
      </div>

      {/* Right — form */}
      <div className="login-form-side">
        <div className="login-form-container">
          <h2 className="login-heading">Zaloguj się</h2>
          <p className="login-subheading">Wpisz dane dostępowe do systemu</p>

          <div className="login-field">
            <label className="login-label" htmlFor="login">
              Login
            </label>
            <input
              className="login-input"
              type="text"
              id="login"
              name="login"
              placeholder="Twój login"
              value={login}
              onChange={(e) => setLogin(e.target.value)}
              onKeyDown={handleKeyDown}
              autoComplete="username"
            />
          </div>

          <div className="login-field">
            <label className="login-label" htmlFor="password">
              Hasło
            </label>
            <input
              className="login-input"
              type="password"
              id="password"
              name="password"
              placeholder="••••••••"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              onKeyDown={handleKeyDown}
              autoComplete="current-password"
            />
          </div>

          <button
            className="login-submit"
            onClick={checkLoginData}
            disabled={submitting}
          >
            {submitting ? "Logowanie..." : "Zaloguj"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Login;
